import { IconName, SymbolBadge } from 'ui/components'
import { CRBIdLicenseHintType } from '~bank-crb-monitor/types'

import { s } from './styles'

type Props = {
  showHintType: CRBIdLicenseHintType
  showHintMessage: string
}

export const LicenseStatusPanel = ({ showHintType, showHintMessage }: Props) => {
  if (!showHintType) {
    return null
  }

  if (showHintType === CRBIdLicenseHintType.DANGER) {
    return (
      <s.Hint isDanger>
        <SymbolBadge color="error" icon={IconName.INFO_ROUND} />
        {showHintMessage}
      </s.Hint>
    )
  }
  if (showHintType === CRBIdLicenseHintType.WARNING) {
    return (
      <s.Hint isWarning>
        <SymbolBadge color="warning" icon={IconName.INFO_ROUND} />
        {showHintMessage}
      </s.Hint>
    )
  }
  return (
    <s.Hint isSuccess>
      <SymbolBadge color="positive" icon={IconName.CHECK_ROUND} />
      {showHintMessage}
    </s.Hint>
  )
}
